<template>
  <div class="info-window">
    <div>
      <div
        class="title-3"
        v-text="$props.careProvider.name"
      />
      <div
        class="body-3"
        v-html="$props.careProvider.address"
      />
    </div>
    <div
      v-if="!showMessage"
      :class="hintClasses"
    >
      <the-icon
        art="light"
        :name="AVAILABILITY_HINT[status].icon"
      />
      <div
        class="body-3"
        v-text="t(`careProvider.status.${status}.title`)"
      />
    </div>
    <basic-message
      v-else
      :severity="AVAILABILITY_HINT[status].severity"
      :closeable="false"
      :title-label="t(`careProvider.status.${status}.title`)"
      :content="t(`careProvider.status.${status}.text`)"
    />
    <basic-button
      v-show="showAction"
      id="info-window-add-button"
      :label="$props.buttonLabel || t('careProvider.add')"
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue'

  import useBrowser from '@shared/hooks/useBrowser'
  import useI18n from '@shared/hooks/useI18n'

  import TheIcon from '@shared/components/Container/TheIcon'
  import { BasicButton, BasicMessage } from '@shared/components/Basic'

  import { AVAILABILITY_HINT } from '@shared/components/CareProvider/constants'

  // HOOKS
  const { isSMViewport } = useBrowser()
  const { t } = useI18n()

  const props = defineProps({
    buttonLabel: {
      type: String,
      default: ''
    },

    careProvider: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  })

  // COMPUTED
  const hintClasses = computed(() => {
    return {
      'info-window__hint': true,
      [`info-window__hint--${status.value}`]: true
    }
  })

  const showAction = computed(() => {
    return props.isActive && isSMViewport.value
  })

  const showMessage = computed(() => {
    return props.isActive && status.value !== 'ACCEPTS_ALL'
  })

  const status = computed(() => {
    // all statuses are considered ACCEPT_ALL except ACCORDING_FAMILY_DOCTOR and ACCEPTS_NOBODY
    const unavailableStatuses = ['ACCORDING_FAMILY_DOCTOR', 'ACCEPTS_NOBODY']
    return unavailableStatuses.includes(props.careProvider.newPatientStatus)
      ? props.careProvider.newPatientStatus
      : 'ACCEPTS_ALL'
  })
</script>

<style scoped>
.info-window {
  display: flex;
  flex-direction: column;
  row-gap: var(--fixed-spacing-fix-04);
}

.info-window__hint {
  display: flex;
  flex-direction: row;
  column-gap: var(--fixed-spacing-fix-02);
  align-items: center;
}

.info-window__hint .icon {
  font-size: 20px;
}

.info-window__hint--ACCEPTS_ALL {
  color: var(--secondary);
}

.info-window__hint--ACCORDING_FAMILY_DOCTOR {
  color: var(--attention);
}

.info-window__hint--ACCEPTS_NOBODY {
  color: var(--error);
}
</style>
